<template>
  <div class="kt-subheader kt-grid__item" id="kt_subheader">
    <div class="kt-subheader__main">
      <template v-for="(obj, index) in routeRecords">
        <h3 class="kt-subheader__title" v-if="isLast(index)">{{ $t(obj.name) }}</h3>
        <h3 class="kt-subheader__title" v-else>
          <router-link :to="obj.route">{{ $t(obj.name) }}</router-link>
        </h3>
        <i class="icon-arrow-right" v-if="!isLast(index)"></i>
      </template>

      <span v-if="show" class="kt-subheader__separator kt-subheader__separator--v"></span>
      <div v-if="show" class="kt-subheader__group" id="kt_subheader_search">
        <span class="kt-subheader__desc" id="kt_subheader_total">{{total}} {{$t('Total')}}</span>

        <form class="kt-margin-l-20" id="kt_subheader_search_form" @submit.prevent="noop">
          <div
            class="kt-input-icon kt-input-icon--right kt-subheader__search"
            v-if="searchFields.length"
          >
            <input
              type="text"
              class="form-control"
              :placeholder="$t('Search...')"
              v-model.lazy="search"
              v-debounce="delay"
              id="generalSearch"
            />
            <span class="kt-input-icon__icon kt-input-icon__icon--right">
              <span>
                <SearchIcon v-if="!search"/>
                <i
                  class="flaticon-cancel"
                  style="color:#22b9ff;cursor:pointer"
                  @click="search=''"
                  v-else
                />
              </span>
            </span>
          </div>
          <div class="kt-subheader__search" v-if="searchFields.length">
            <select
              class="form-control"
              v-model="searchField"
              style="margin-left:.5rem;padding: 0 1rem;"
            >
              <option
                v-for="item in searchFields"
                v-bind:key="item.value"
                :value="item.value"
              >{{$t(item.label)}}</option>
            </select>
          </div>
        </form>
      </div>
    </div>
    <div v-if="show && showAdd && addLabel" class="kt-subheader__toolbar">
      <a href="#" class="btn btn-label-brand btn-bold" @click.prevent="addClick">{{$t(addLabel)}}</a>
    </div>
  </div>
</template>

<script>
import { evbus, EVENTS } from "@/shared/evbus";
import debug from "@/shared/debug";
import debounce from "@/shared/debounce";
import SearchIcon from "./SearchIcon";

export default {
  components: {
    SearchIcon
  },
  directives: { debounce },
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      show: false,
      showAdd: false,
      addLabel: "",
      search: "",
      searchField: "",
      searchFields: [],
      total: 0,
      delay: 500
    };
  },
  watch: {
    search(newVal) {
      if (this.searchField == "cnp" && newVal.length < 7) {
        return;
      }
      evbus.emit(EVENTS.DO_SEARCH, {
        filter: newVal,
        filterField: JSON.parse(JSON.stringify(this.searchField))
      });
    },
    searchField(newVal) {
      if (this.search) {
        if (newVal == "cnp" && this.search.length < 7) {
          return;
        }
        evbus.emit(EVENTS.DO_SEARCH, {
          filter: JSON.parse(JSON.stringify(this.search)),
          filterField: newVal
        });
      }
    }
  },
  computed: {
    routeRecords: function() {
      const self = this;
      const items = this.list.filter(route => route.name || route.meta.label);
      const res = [];
      items.forEach(item => {
        res.push({
          name:
            item.meta && item.meta.label ? item.meta.label : item.name || null,
          route: item
        });
      });
      if (res[0].route.path == "") {
        res[0].route.path = "/home";
      }
      return res;
    }
  },
  methods: {
    noop() {},
    isLast(index) {
      return index === this.list.length - 1;
    },
    showSubHeader(data, eventType) {
      this.show = true;
      if (data.showAdd) {
        this.showAdd = true;
        this.addLabel = data.addLabel;
      }
      if (data.searchFields.length) {
        this.searchFields = data.searchFields;
        this.searchField = data.searchFields[0].value;
      }

      if (data.total) {
        this.total = data.total;
      } else {
        this.total = 0;
      }
    },
    hideSubHeader() {
      this.show = false;
      this.showAdd = false;
      this.total = 0;
      this.addLabel = "";
      this.search = "";
      this.searchField = "";
      this.searchFields = [];
    },
    updateSubHeader(data, eventType) {
      if (data.total) {
        this.total = data.total;
      } else {
        this.total = 0;
      }
    },
    addClick() {
      evbus.emit(EVENTS.DO_ADD);
    }
  },
  mounted() {
    this.showSubHeaderCB = this.showSubHeader.bind(this);
    this.hideSubHeaderCB = this.hideSubHeader.bind(this);
    this.updateSubHeaderCB = this.updateSubHeader.bind(this);
    evbus.on(EVENTS.SHOW_SUBHEADER_OPTIONS, this.showSubHeaderCB);
    evbus.on(EVENTS.HIDE_SUBHEADER_OPTIONS, this.hideSubHeaderCB);
    evbus.on(EVENTS.UPDATE_SUBHEADER_OPTIONS, this.updateSubHeaderCB);
  },
  destroyed() {
    evbus.remove(EVENTS.SHOW_SUBHEADER_OPTIONS, this.showSubHeaderCB);
    evbus.remove(EVENTS.HIDE_SUBHEADER_OPTIONS, this.hideSubHeaderCB);
    evbus.remove(EVENTS.UPDATE_SUBHEADER_OPTIONS, this.updateSubHeaderCB);
  }
};
</script>

<style lang="scss" scoped>
.icon-arrow-right {
  color: #e7e8ef;
  margin-right: 10px;
}
</style>
